import {BREAK_POINTS} from '../setting';

export default function() {

	function gnav() {
		const $navBtn = $('.js-gnav');
		const $navFixedBtn = $('.js-fixed-item .js-gnav');
		const $navWrapper = $('.js-gnav-wrapper');
		const $navTarget = $('.js-gnav-target');
		const $body = $('body');

		$navTarget.addClass('is-transition');

		$navBtn.on('click', function(){
			$navBtn.toggleClass('is-active');
			if($navBtn.hasClass('is-active')) {
				$body.css({overflow:'hidden'});
				$navWrapper.attr({'aria-expanded':'true'});
				$navTarget.attr({'aria-hidden':'false'});
				$navTarget.addClass('is-show');
				$navTarget.fadeIn();
			}else {
				$body.css({overflow:'auto'});
				$navWrapper.attr({'aria-expanded':'false'});
				$navTarget.attr({'aria-hidden':'true'});
				$navTarget.removeClass('is-show');
				$navTarget.fadeOut();
			}
		});

		$navFixedBtn.on('click', function(){
			if($navFixedBtn.hasClass('is-active')) {
				$(this).parents('.js-fixed-item').addClass('is-show');
			}else {
				$(this).parents('.js-fixed-item').removeClass('is-show');
			}
		});
	}

	$(window).on('load', () => {
		gnav();
	});
}
